import { CallbackDialog } from "@/components/CallbackDialog";
import { CTAPanel } from "@/components/home/CTAPanel";
import { useOrg } from "@/contexts/OrgContext";
import { useCompanyInfoFull } from "@/hooks/useCompanyInfo";
import { useTenantPath } from "@/hooks/useTenantPath";
import { formatAreas } from "@/lib/service-areas";
import { useDemoShowcase } from "@/hooks/useDemoShowcase";

export function CTA() {
  const { orgId } = useOrg();
  const tenantPath = useTenantPath();
  const { data: companyInfo } = useCompanyInfoFull(orgId);
  const areas = companyInfo?.service_areas ?? [];
  const demo = useDemoShowcase();

  if (demo) {
    return (
      <CTAPanel
        title={demo.cta.title}
        subtitle={demo.cta.subtitle}
        buttonText="Try the booking form"
        buttonHref={tenantPath("/booking")}
        secondary={<CallbackDialog variant="cta" />}
        checklist={demo.cta.checklist}
      />
    );
  }

  return (
    <CTAPanel
      title="Ready for a spotless home?"
      subtitle={
        <>
          Pick a time that suits you and book your clean online in about a minute.
        </>
      }
      buttonText="Book my cleaning"
      buttonHref={tenantPath("/booking")}
      secondary={<CallbackDialog variant="cta" />}
      checklist={[
        ...(areas.length > 0 ? [`Serving ${formatAreas(areas)}`] : []),
        "Same-day availability",
        "Satisfaction guaranteed",
      ]}
    />
  );
}
